import { $myFetch } from "."

export const $getCustoms = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "customs",
    {
      headers: myHeaders
    },
    []
  )
}
